'use client';
import React, { useEffect, useRef, useState } from 'react';

const stats = [
  { value: '30+', label: 'Funcionalidades', icon: '⚡' },
  { value: '100%', label: 'Sistema Online', icon: '🌐' },
  { value: '24h', label: 'Suporte', icon: '🛡️' },
  { value: '∞', label: 'Atualizações', icon: '🔄' },
  { value: 'Multi', label: 'Empresa', icon: '🏢' },
  { value: 'Multi', label: 'Usuários', icon: '👥' },
  { value: 'Auto', label: 'Backup', icon: '💾' },
  { value: 'ISO', label: 'Segurança', icon: '🔒' },
];

export default function StatsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.2 }
    );
    if (ref?.current) observer?.observe(ref?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-16 border-y border-border relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/3 via-transparent to-secondary/3" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-0">
          {stats?.map((stat, i) => (
            <div
              key={stat?.label}
              className={`stat-item flex flex-col items-center text-center px-4 py-6 transition-all duration-500 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <span className="text-2xl mb-2">{stat?.icon}</span>
              <span className="text-2xl font-black gradient-text-green">{stat?.value}</span>
              <span className="text-xs text-muted-foreground mt-1 font-medium">{stat?.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}